import React, { FC } from 'react';
import { Box, Container, Divider, Grid, Theme, Typography, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { BgImage } from 'images/main';

interface ExperienceTextSectionProps {
  title: string;
  description: string;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      marginTop: theme.spacing(22),
      backgroundImage: `url(${BgImage})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      padding: theme.spacing(10, 0, 20),
      [theme.breakpoints.up('sm')]: {
        backgroundSize: 450,
        marginTop: theme.spacing(15),
        padding: theme.spacing(10, 0, 30),
      },
    },
    title: {
      color: theme.palette.primary.main,
      fontWeight: 500,
    },
    text: {
      color: theme.palette.primary.dark,
      lineHeight: 1.6,
      padding: theme.spacing(0, 2.5),
      [theme.breakpoints.up('sm')]: {
        lineHeight: 1.8,
      },
    },
    divider: {
      backgroundColor: theme.palette.primary.main,
      maxWidth: 100,
      margin: '0 auto',
    },
  });
});

const ExperienceTextSection: FC<ExperienceTextSectionProps> = ({ title, description }) => {
  const classes = useStyles();
  const isSmallUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  return (
    <Container fixed className={classes.root}>
      <Grid container direction="row" justifyContent="center">
        <Grid item md={12}>
          <Typography align="center" variant={isSmallUp ? 'h2' : 'h3'} className={classes.title} data-aos="fade-up">
            {title}
          </Typography>
          <Box mb={7} />
        </Grid>
        <Grid xs={12} item>
          <Divider className={classes.divider} />
        </Grid>
        <Grid item md={9}>
          <Box mt={6} />
          <Typography align="center" variant="h5" className={classes.text} data-aos="fade-up">
            {description}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ExperienceTextSection;
